import { createFileRoute } from '@tanstack/react-router'

import PindahDomisiliPage from '@/components/pages/backoffice/_ktg-penyuluh/pindah-domisili/containers/PindahDomisiliPage'

export const Route = createFileRoute(
  '/_backoffice/ktg-penyuluh/pindah-domisili/',
)({
  component: PindahDomisiliPage,
})
